module.exports = __webpack_public_path__ + "static/media/cardshilow.d1f79a72.jpeg";